import { render } from "./RSMs.vue?vue&type=template&id=68a9d0aa"
import script from "./RSMs.vue?vue&type=script&lang=js"
export * from "./RSMs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__